import * as React from 'react';
import s from './mobileNavigation.scss';
import {filter, products} from '../../../routes/navigation';
import SearchBox from '../../../containers/SearchBox';
import {withTranslation} from 'react-i18next';
import NavigationLink from '../NavigationLink';
import {logger} from '../../../utils/bi';
import {History} from 'history';
import {Experiment} from '../../../reducers/experiments';

const filterCategories = filter();

export type MobileNavigationProps = {
  show: boolean,
  gotResults?: boolean,
  history: History,
  experiments?: Experiment[];
  t?: (...args: any[]) => any,
  toggleMenu?: (...args: any[]) => any
};

class MobileNavigation extends React.Component<MobileNavigationProps, {}> {
  commonCloseClickHandler(buttonLabel?) {
    this.props.toggleMenu(false);
    if (buttonLabel) {
      logger({
        evid: 334,
        button_name: buttonLabel.toLowerCase(),
        location: 'mobile navigation'
      });
    }
  }
  componentDidUpdate() {
    document
      .getElementsByTagName('body')[0]
      .classList.toggle('disabled', this.props.show);
    const filterMenu = document.getElementById('filter-options-menu');
    if (filterMenu && !this.props.show) {
      filterMenu.scrollTop = 0;
    }
  }
  render() {
    const {t, show, history} = this.props;
    const showFilter = show ? s.show : '';
    const productsCategories = products();

    return (
      <div className={`${s.filterOptions} ${showFilter}`} role="dialog">
        <button
          data-hooks="mobile-navigation-close-button"
          className={s.closeIcon}
          onClick={() => this.commonCloseClickHandler()}
        >
          <span className={s.hidden}>
            {t('mobile.navigation.close.button')}
          </span>
        </button>
        <ul className={s.optionsList} id="filter-options-menu">
          <li>
            <SearchBox history={history} mobile={show} />
          </li>
          <li className={s.title}>{t('wix.general.page.filter.by')}</li>
          {filterCategories.map((link, index) => (
            <NavigationLink
              key={index}
              link={link}
              onClickHandler={buttonLabel =>
                this.commonCloseClickHandler(buttonLabel)
              }
            />
          ))}
          <li className={`${s.title} ${s.spacer}`}>
            {t('navigation.wix.products.title')}
          </li>
          {productsCategories.map((link, index) => (
            <NavigationLink
              key={index}
              link={link}
              onClickHandler={buttonLabel =>
                this.commonCloseClickHandler(buttonLabel)
              }
            />
          ))}
        </ul>
      </div>
    );
  }
}
export default withTranslation()(MobileNavigation);
